/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimensionLabelDetail } from './RiskDimensionLabelDetail';
import {
  RiskDimensionLabelDetailFromJSON,
  RiskDimensionLabelDetailFromJSONTyped,
  RiskDimensionLabelDetailToJSON,
} from './RiskDimensionLabelDetail';

/**
 *
 * @export
 * @interface RiskLabelCount
 */
export interface RiskLabelCount {
  /**
   *
   * @type {Array<RiskDimensionLabelDetail>}
   * @memberof RiskLabelCount
   */
  labels: Array<RiskDimensionLabelDetail>;
  /**
   *
   * @type {string}
   * @memberof RiskLabelCount
   */
  readonly colorOrder: string;
  /**
   *
   * @type {string}
   * @memberof RiskLabelCount
   */
  readonly residualRiskLabel: string;
  /**
   *
   * @type {number}
   * @memberof RiskLabelCount
   */
  count: number;
}

/**
 * Check if a given object implements the RiskLabelCount interface.
 */
export function instanceOfRiskLabelCount(value: object): value is RiskLabelCount {
  if (!('labels' in value) || value['labels'] === undefined) return false;
  if (!('colorOrder' in value) || value['colorOrder'] === undefined) return false;
  if (!('residualRiskLabel' in value) || value['residualRiskLabel'] === undefined) return false;
  if (!('count' in value) || value['count'] === undefined) return false;
  return true;
}

export function RiskLabelCountFromJSON(json: any): RiskLabelCount {
  return RiskLabelCountFromJSONTyped(json, false);
}

export function RiskLabelCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskLabelCount {
  if (json == null) {
    return json;
  }
  return {
    labels: (json['labels'] as Array<any>).map(RiskDimensionLabelDetailFromJSON),
    colorOrder: json['color_order'],
    residualRiskLabel: json['residual_risk_label'],
    count: json['count'],
  };
}

export function RiskLabelCountToJSON(value?: Omit<RiskLabelCount, 'colorOrder' | 'residualRiskLabel'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    labels: (value['labels'] as Array<any>).map(RiskDimensionLabelDetailToJSON),
    count: value['count'],
  };
}
